import React, { useState } from 'react';

import styled from 'styled-components';

import FlexContainer from '@components/Gui/FlexContainer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import SendProjectDrawerFromEvent from '@components/SendProjectAgendaDrawer/SendProjectDrawerFromEvent';

import { EventModelNameLineNonBooking } from './EventModelNameLineNonBooking';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

// Event types the project schedule export can handle
const EXPORTABLE_EVENT_TYPES = ['Travel', 'Accommodation'];

const EventTitleContainer = styled.div`
    padding: 1rem 1.5rem;

    h1,
    h2,
    p {
        margin-bottom: 0;
    }

    &.cancel {
        h2 {
            ${(props) => props.theme.RedLineThrough(2)}
        }
    }
`;

export const EventTitle = (props) => {
    const [sendProjectDrawer, setSendProjectDrawer] = useState(false);

    const isMeeting = props.eventProperties.eventType === 'Meeting';
    const isScoutingAccommodation = props.eventProperties.eventType === 'ScoutingAccommodation';
    const canSendSchedule =
        Boolean(props.event.Project) && EXPORTABLE_EVENT_TYPES.includes(props.eventProperties.eventType);

    const buttonactions = [
        { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: props.actions.onEditGeneral },
    ];
    if (canSendSchedule) {
        buttonactions.unshift({
            name: '',
            key: 'send-schedule',
            pinned: true,
            tooltip: 'Send schedule by e-mail',
            icon: byPrefixAndName.fasl['share'],
            action: () => setSendProjectDrawer(true),
        });
    }
    if (props.actions.onDeleteGroup) {
        buttonactions.push({
            name: 'delete all models/dates',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: props.actions.onDeleteGroup,
        });
    }
    if ((isMeeting || isScoutingAccommodation) && props.actions.onDelete) {
        buttonactions.push({
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: props.actions.onDelete,
        });
    }
    if (props.event.Project) {
        buttonactions.push({
            name: 'unlink from project',
            key: 'unlink-project',
            icon: byPrefixAndName.fasl['trash-alt'],
            action: props.actions.onProjectUnlink,
        });
    }

    const renderSendProjectDrawer = () =>
        sendProjectDrawer && (
            <SendProjectDrawerFromEvent
                event={props.event}
                eventType={props.eventProperties.eventType}
                onClose={() => setSendProjectDrawer(false)}
            />
        );

    const isGloballyCancelled = () => {
        if (props.event.Cancel) {
            if (props.event.RelatedEvents && props.event.RelatedEvents.length > 0) {
                if (props.event.RelatedEvents.every((e) => e.Cancel)) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }
        return false;
    };

    if (!props.eventProperties.isSingle || isMeeting || isScoutingAccommodation) {
        return (
            <EventTitleContainer className={isGloballyCancelled() ? 'cancel' : null}>
                <FlexContainer justifyContent="space-between">
                    <h2>{props.event.Title}</h2>
                    <div>
                        <NwDropDownMenu right actions={buttonactions} />
                    </div>
                </FlexContainer>
                {renderSendProjectDrawer()}
            </EventTitleContainer>
        );
    } else {
        return (
            <EventTitleContainer className={isGloballyCancelled() ? 'cancel' : null}>
                <EventModelNameLineNonBooking
                    {...props}
                    aboveTitle
                    onSendSchedule={canSendSchedule ? () => setSendProjectDrawer(true) : null}
                />
                <h2>{props.event.Title}</h2>
                {renderSendProjectDrawer()}
            </EventTitleContainer>
        );
    }
};
